"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mentionSuggestionFilter = void 0;
var AddCommentInput_1 = require("../AddCommentComponent/AddCommentInput");
var mobx_1 = require("mobx");
var PermissionTypes_1 = require("../../../DataStores/Permissions/PermissionTypes");
var Types_1 = require("@CommonFrontendBackend/Permissions/Types");
var GetFullName_1 = __importDefault(require("@CommonFrontendBackend/Utils/GetFullName"));
var queryMatchesSuggestionCaseInsensitive = function (suggestion, query) {
    return suggestion.toLowerCase().indexOf(query.toLowerCase()) > -1;
};
var queryMatchesNameOrEmail = function (fullName, email, query) {
    return queryMatchesSuggestionCaseInsensitive(fullName, query) || queryMatchesSuggestionCaseInsensitive(email, query);
};
var userHasPermission = function (user) {
    return [Types_1.Action.All, Types_1.Action.Edit].includes(user.permission);
};
var processUserPermissions = function (users, query) {
    var permittedResults = [];
    var unpermittedResults = [];
    users.forEach(function (user) {
        var fullName = (0, PermissionTypes_1.isExistingUser)(user) ? (0, GetFullName_1.default)(user) : "";
        if (queryMatchesNameOrEmail(fullName, user.email, query)) {
            var result = {
                display: fullName || user.email,
                id: user.id,
            };
            if (userHasPermission(user)) {
                permittedResults.push(result);
            }
            else {
                unpermittedResults.push(result);
            }
        }
    });
    return {
        permittedResults: permittedResults,
        unpermittedResults: unpermittedResults,
    };
};
var combineResults = function (firstResults, secondResults) {
    return {
        permittedResults: firstResults.permittedResults.concat(secondResults.permittedResults),
        unpermittedResults: firstResults.unpermittedResults.concat(secondResults.unpermittedResults),
    };
};
var spacesRegex = /\s/g;
var mentionSuggestionFilter = function (permissions) {
    return function (query, callback) {
        (0, mobx_1.when)(function () { return !permissions.isLoading; }, function () {
            var _a = combineResults(processUserPermissions(permissions.permittedUsers, query), processUserPermissions(permissions.unpermittedUsers, query)), permittedResults = _a.permittedResults, unpermittedResults = _a.unpermittedResults;
            var results = __spreadArray(__spreadArray([], __read(permittedResults), false), __read(unpermittedResults), false);
            if (results.length === 0 && query.search(spacesRegex) < 0) {
                results.push({
                    display: query,
                    id: AddCommentInput_1.ExternalMentionMarkerId,
                });
            }
            callback(results);
        });
    };
};
exports.mentionSuggestionFilter = mentionSuggestionFilter;
